import React from 'react'

const IncludeSection = ({ mainImage, heading, items }) => {
  return (
    <section className="flex flex-col bg-light lg:flex-row items-center gap-8 px-4 md:px-6 py-8 md:py-12 max-w-6xl mx-auto">
      {/* Left Side - Main Image */}
      <div className="relative w-full lg:w-5/12 flex justify-center">
        <img
          src={mainImage}
          alt="What's Included"
          className="rounded-xl shadow-md w-full max-w-xs md:max-w-sm h-auto object-cover"
        />
      </div>

      {/* Right Side - Items */}
      <div className="w-full lg:w-7/12 flex flex-col items-start">
        <h2 className="text-2xl md:text-3xl font-bold text-secondary mb-6 text-center lg:text-left w-full">
          {heading}
        </h2>

        <div className="space-y-6 w-full">
          {items.map((section, index) => (
            <div
              key={index}
              className="bg-white p-4 rounded-lg shadow hover:shadow-lg transition"
            >
              <div className="flex items-center mb-2">
                <span className="text-2xl mr-2">{section.icon}</span>
                <h3 className="text-lg md:text-xl font-semibold text-primary">
                  {section.heading}
                </h3>
              </div>
              <ul className="list-disc list-inside text-gray-700 pl-1 space-y-1 text-sm md:text-base">
                {section.points.map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};


export default IncludeSection;